import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { brand } from './brand/brand'
import { DemoLockOverlay } from './components/DemoLockOverlay'
import { ErrorBoundary } from './components/ErrorBoundary'
import { ThemeProvider } from './contexts/ThemeContext'
import { initTracker } from './lib/tracker'
import './index.css'

// Analytics is per-brand data (brand pack `analytics` flag) — enabled for the
// AI Overlords demos only; the generated twin ships analyticsEnabled: false.
if (brand.analyticsEnabled) initTracker({ site: brand.analyticsSite })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <App />
          <DemoLockOverlay />
        </BrowserRouter>
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>,
)
